import {
    getCachedLanguage,
    Languages,
} from '@uipath/portal-shell-util';

import en from '../../locale/en.json';
import { isDefined } from '../helper';
import {
    localeMap,
    templateMatcher,
} from './locHelper';

export function getLanguageText(languageCode: string) {
    return Languages[languageCode.toLowerCase()] || languageCode;
}

export function t(key: string, locale: string = getCachedLanguage(), params?: any) {
    locale = locale?.toLowerCase();
    const value = localeMap[locale]?.[key] || en[key] || key;
    return interpolateString(value, params);
}

/**
 * Interpolates a string to replace parameters
 * "This is a {{ key }}" ==> "This is a value", with params = { key: "value" }
 * @param expr
 * @param params
*/
function interpolateString(expr: string, params?: any) {
    if (!params) {
        return expr;
    }

    return expr.replace(templateMatcher, (substring: string, key: string) => {
        const r = params[key];
        return isDefined(r) ? r : substring;
    });
}
